$.extend({
    createElement : function (elementName) {
        return $(document.createElement(elementName));
    }
});

function kombinaceDruhuZjednodusenePodminkaNactiHodnoty(elementName, idDruh) {
    var element = $('#' + elementName);
    var typ = element.parents('div.kombinaceDruhuZjednodusene').data('typ');
    var elementDataHodnoty = $('#' + typ + '-data-hodnoty-' + idDruh);

    element.children().remove();

    if (elementDataHodnoty.children().length >= 1) {
        element.html(elementDataHodnoty.html());

        element.removeClass('hidden');
        $('#' + elementName.replace('idHodnota', 'od')).addClass('hidden').val('');
        $('#' + elementName.replace('idHodnota', 'do')).addClass('hidden').val('');
        $('#' + elementName.replace('idHodnota', 'presne')).addClass('hidden').val('');
    } else {
        element.addClass('hidden');
        $('#' + elementName.replace('idHodnota', 'od')).removeClass('hidden');
        $('#' + elementName.replace('idHodnota', 'do')).removeClass('hidden');
        $('#' + elementName.replace('idHodnota', 'presne')).removeClass('hidden');
    }

    if (idDruh === '' || idDruh === 0) {
        element.addClass('hidden');
        $('#' + elementName.replace('idHodnota', 'od')).addClass('hidden');
        $('#' + elementName.replace('idHodnota', 'do')).addClass('hidden');
        $('#' + elementName.replace('idHodnota', 'presne')).addClass('hidden');
    }
}

function kombinaceDruhuZjednodusenePodminkaPreindexovat(elTabulka) {
    $(elTabulka).find('tbody > tr').each(function (indexPodminka, elTr) {
        indexPodminka++;
        $(elTr).attr('data-podminka', indexPodminka);
        $(elTr).find('input, textarea, select').each(function (b, element) {
            if (element.getAttribute('name') != null) {
                element.name = element.name.replace(/podminky\]\[(\d+)\]/, 'podminky][' + indexPodminka + ']');
            }

            if (element.getAttribute('id') != null) {
                element.id = element.id.replace(/-podminky-(\d+)-/, '-podminky-' + indexPodminka + '-');
            }
        });
    });
}

function kombinaceDruhuZjednodusenePodminkaPridat(element) {
    var elSkupina = $(element).parents('.kombinaceDruhuZjednodusene-skupina');
    var indexSkupina = $(element).parents('.kombinaceDruhuZjednodusene-skupina').data('skupina');
    var indexPodminka = $(elSkupina).find('tbody > tr').length + 1;
    var typ = $(element).parents('.kombinaceDruhuZjednodusene').data('typ');
    var onkeydown = "return keyPress(this.id, event),";

    var tr = $(document.createElement('tr'))
        .attr('class', 'kombinaceDruhuZjednodusene-podminka')
        .attr('data-podminka', indexPodminka);

    var td1 = $(document.createElement('td'));
    var td2 = $(document.createElement('td'));
    var td3 = $(document.createElement('td'));
    var td4 = $(document.createElement('td'));
    var td5 = $(document.createElement('td'));
    var td6 = $(document.createElement('td')).attr('class', 'text-center');

    var selectIdDruh = $(document.createElement("select"))
        .attr('id', typ + '-' + indexSkupina + '-podminky-' + indexPodminka + '-idDruh')
        .attr('name', typ + '[' + indexSkupina + '][podminky][' + indexPodminka + '][idDruh]')
        .attr('class', 'form-control input-sm idDruh')
        .html($('#' + typ + '-data-druhy').html());

    var selectIdHodnota = $(document.createElement("select"))
        .attr('id', typ + '-' + indexSkupina + '-podminky-' + indexPodminka + '-idHodnota')
        .attr('name', typ + '[' + indexSkupina + '][podminky][' + indexPodminka + '][idHodnota]')
        .attr('class', 'form-control input-sm hidden');

    var inputOd = $(document.createElement("input"))
        .attr('type', 'text')
        .attr('id', typ + '-' + indexSkupina + '-podminky-' + indexPodminka + '-od')
        .attr('name', typ + '[' + indexSkupina + '][podminky][' + indexPodminka + '][od]')
        .attr('class', 'form-control input-sm text-right hidden')
        .attr('size', 4)
        .attr('onkeydown', onkeydown);

    var inputDo = $(document.createElement("input"))
        .attr('type', 'text')
        .attr('id', typ + '-' + indexSkupina + '-podminky-' + indexPodminka + '-do')
        .attr('name', typ + '[' + indexSkupina + '][podminky][' + indexPodminka + '][do]')
        .attr('class', 'form-control input-sm text-right hidden')
        .attr('size', 4)
        .attr('onkeydown', onkeydown);

    var inputPresne = $(document.createElement("input"))
        .attr('type', 'text')
        .attr('id', typ + '-' + indexSkupina + '-podminky-' + indexPodminka + '-presne')
        .attr('name', typ + '[' + indexSkupina + '][podminky][' + indexPodminka + '][presne]')
        .attr('class', 'form-control input-sm text-right hidden')
        .attr('size', 4)
        .attr('onkeydown', onkeydown);

    var hrefSmazat = '<button class="kombinaceDruhuZjednodusene-podminka-smazat btn btn-xs btn-grey"><i class="fas fa-trash fa-fw"></a>';

    td1.append(selectIdDruh);
    td2.append(selectIdHodnota);
    td3.append(inputOd);
    td4.append(inputDo);
    td5.append(inputPresne);
    td6.append(hrefSmazat);

    tr.append(td1);
    tr.append(td2);
    tr.append(td3);
    tr.append(td4);
    tr.append(td5);
    tr.append(td6);

    $(elSkupina).find('tbody').append(tr);

    return false;
}

function kombinaceDruhuZjednodusenePodminkaSmazat(element) {
    var elTabulka = $(element).parents('table');
    var elTd = $(element).parents('td');
    var elPodminkaId = $(elTd).find(':hidden');
    var typ = $(element).parents('.kombinaceDruhuZjednodusene').data('typ');

    if ($(elPodminkaId).length > 0) {
        var el = $.createElement('input')
            .attr('type', 'hidden')
            .attr('name', typ + '-smazanePodminky[]')
            .val($(elPodminkaId).val());

        $('#' + typ).append(el);
    }

    $(element).parents('tr').remove();

    kombinaceDruhuZjednodusenePodminkaPreindexovat(elTabulka);
}

function kombinaceDruhuZjednoduseneSkupinaDuplikovat(element) {
    var elSkupina = $(element).parents('.kombinaceDruhuZjednodusene-skupina');
    var elSkupiny = elSkupina.parents('.kombinaceDruhuZjednodusene-skupiny');
    var elPridatSkupinuP = $(elSkupiny).find('.kombinaceDruhuZjednodusene-skupina-pridat').parent();
    var elPridatSkupinuPClone = $(elPridatSkupinuP).clone();
    var nova = elSkupina.clone();
    var indexSkupina = $(elSkupiny).find('.kombinaceDruhuZjednodusene-skupina').length + 1;

    nova.find('input[type="hidden"]').remove();
    nova.appendTo(elSkupiny);

    if (indexSkupina > 1) {
        $(elPridatSkupinuP).html('nebo').addClass('text-muted');
    } else {
        $(elPridatSkupinuP).remove();
    }

    $(elSkupiny).append(elPridatSkupinuPClone);

    kombinaceDruhuZjednoduseneSkupinaPreindexovat(elSkupiny);

    return false;
}

function kombinaceDruhuZjednoduseneSkupinaPreindexovat(elSkupiny) {
    $(elSkupiny).find('table').each(function(indexSkupina, elTable) {
        indexSkupina++;
        $(elTable).attr('data-skupina', indexSkupina);

        $(elTable).find('tbody > tr').each(function(indexPodminka, elTr) {
            indexPodminka++;
            $(elTr).attr('data-podminka', indexPodminka);

            $(elTr).find('input, textarea, select').each(function (index, element) {
                if (null !== element.getAttribute('name')) {
                    element.name = element.name.replace(
                        /\[(\d+)\]\[podminky\]\[(\d+)\]/,
                        '[' + indexSkupina + '][podminky][' + indexPodminka + ']'
                    );
                }

                if (null !==  element.getAttribute('id')) {
                    element.id = element.id.replace(
                        /(\d+)-podminky-(\d+)/,
                        indexSkupina + '-podminky-' + indexPodminka
                    );
                }
            });
        });

        $(elTable).find('tfoot > tr').each(function(indexRadek, elTr) {
            $(elTr).find('input').each(function (index, element) {
                if (null !== element.getAttribute('name')) {
                    element.name = element.name.replace(/\[(\d+)\]\[id\]$/, '[' + indexSkupina + '][id]');
                }

                if (null !==  element.getAttribute('id')) {
                    element.id = element.id.replace(/(\d+)-id/, indexSkupina + '-id');
                }
            });
        });
    });
}

function kombinaceDruhuZjednoduseneSkupinaPridat(element) {
    var elSkupiny = $(element).parents('.kombinaceDruhuZjednodusene-skupiny');
    var elPridatSkupinuP = $(elSkupiny).find('.kombinaceDruhuZjednodusene-skupina-pridat').parent();
    var elPridatSkupinuPClone = $(elPridatSkupinuP).clone();
    var indexSkupina = $(elSkupiny).find('.kombinaceDruhuZjednodusene-skupina').length + 1;

    var table = $(document.createElement('table'))
        .attr('class', 'table table-bordered table-striped kombinaceDruhuZjednodusene-skupina')
        .attr('data-skupina', indexSkupina);

    var thead = $(document.createElement('thead'));
    var theadTr = $(document.createElement('tr'));
    var tbody = $(document.createElement('tbody'));
    var tfoot = $(document.createElement('tfoot'));
    var tfootTr = $(document.createElement('tr'));

    var theadThDruh = $(document.createElement('th')).html('Druh').attr('class', 'width-25');
    var theadThHodnota = $(document.createElement('th')).html('Hodnota').attr('class', 'width-40');
    var theadThOd = $(document.createElement('th')).html('Od').attr('class', 'width-10');
    var theadThDo = $(document.createElement('th')).html('Do').attr('class', 'width-10');
    var theadThPresne = $(document.createElement('th')).html('Přesně').attr('class', 'width-10');
    var theadThSmazat = $(document.createElement('th')).attr('class', 'width-5');
    var tfootTdLeva = $(document.createElement('td')).attr('colspan', '2');
    var tfootTdPrava = $(document.createElement('td')).attr('colspan', '4').attr('class', 'text-right');

    var buttonPridatPodminku = $(document.createElement('button'))
        .attr('class', 'kombinaceDruhuZjednodusene-podminka-pridat btn btn-xs btn-grey');

    var buttonPridatPodminkuIcon = $(document.createElement('i'))
        .attr('class', 'fas fa-plus fa-fw');

    var buttonSmazatSkupinu = $(document.createElement('button'))
        .attr('class', 'kombinaceDruhuZjednodusene-skupina-smazat btn btn-xs btn-grey');

    var buttonSmazatSkupinuIcon = $(document.createElement('i'))
        .attr('class', 'fas fa-trash fa-fw');

    theadTr.append(theadThDruh);
    theadTr.append(theadThHodnota);
    theadTr.append(theadThOd);
    theadTr.append(theadThDo);
    theadTr.append(theadThPresne);
    theadTr.append(theadThSmazat);

    thead.append(theadTr);

    buttonPridatPodminku
        .append(buttonPridatPodminkuIcon)
        .append(' Přidat podmínku');
    buttonSmazatSkupinu
        .append(buttonSmazatSkupinuIcon)
        .append(' Smazat skupinu');

    tfootTdLeva.append(buttonPridatPodminku);
    tfootTdPrava.append(buttonSmazatSkupinu);

    tfootTr.append(tfootTdLeva);
    tfootTr.append(tfootTdPrava);

    tfoot.append(tfootTr);

    table.append(thead);
    table.append(tbody);
    table.append(tfoot);

    if (indexSkupina > 1) {
        $(elPridatSkupinuP).html('nebo').addClass('text-muted');
    } else {
        $(elPridatSkupinuP).remove();
    }

    $(elSkupiny).append(table);
    $(elSkupiny).append(elPridatSkupinuPClone);

    kombinaceDruhuZjednoduseneInit();

    return false;
}

function kombinaceDruhuZjednoduseneSkupinaSmazat(element) {
    var elTd = $(element).parents('td');
    var elTable = $(elTd).parents('table');
    var elSkupiny = $(elTable).parents('.kombinaceDruhuZjednodusene-skupiny');
    var elSkupinaId = $(elTd).find(':hidden');
    var indexSkupina = parseInt($(elTable).data('skupina'));
    var prefix = $(element).parents('.kombinaceDruhuZjednodusene:first').data('typ');

    if ($(elSkupinaId).length > 0) {
        var el = $.createElement('input')
            .attr('type', 'hidden')
            .attr('name', prefix + '-smazaneSkupiny[]')
            .val($(elSkupinaId).val());

        $('#' + prefix).append(el);
    }

    if (indexSkupina > 1) {
        $(elTable).prev('p').remove();
    }
    if (1 === indexSkupina && $(elSkupiny).find('.kombinaceDruhuZjednodusene-skupina').length > 1) {
        $(elTable).next('p').remove();
    }

    $(elTable).remove();

    kombinaceDruhuZjednoduseneSkupinaPreindexovat(elSkupiny);
}

function kombinaceDruhuZjednoduseneInit()
{
    $('.kombinaceDruhuZjednodusene').on('change', '.idDruh', function () {
        var id = $(this).attr('id').replace('idDruh', 'idHodnota');
        var value = $(this).val();

        kombinaceDruhuZjednodusenePodminkaNactiHodnoty(id, value);
    });

    $('.kombinaceDruhuZjednodusene').off('click', '.kombinaceDruhuZjednodusene-podminka-pridat');
    $('.kombinaceDruhuZjednodusene').on('click', '.kombinaceDruhuZjednodusene-podminka-pridat', function () {
        kombinaceDruhuZjednodusenePodminkaPridat(this);

        return false;
    });

    $('.kombinaceDruhuZjednodusene').off('click', '.kombinaceDruhuZjednodusene-podminka-smazat');
    $('.kombinaceDruhuZjednodusene').on('click', '.kombinaceDruhuZjednodusene-podminka-smazat', function () {
        kombinaceDruhuZjednodusenePodminkaSmazat(this);

        return false;
    });

    $('.kombinaceDruhuZjednodusene').off('click', '.kombinaceDruhuZjednodusene-skupina-pridat');
    $('.kombinaceDruhuZjednodusene').on('click', '.kombinaceDruhuZjednodusene-skupina-pridat', function () {
        kombinaceDruhuZjednoduseneSkupinaPridat(this);

        return false;
    });

    $('.kombinaceDruhuZjednodusene').off('click', '.kombinaceDruhuZjednodusene-skupina-duplikovat');
    $('.kombinaceDruhuZjednodusene').on('click', '.kombinaceDruhuZjednodusene-skupina-duplikovat', function () {
        kombinaceDruhuZjednoduseneSkupinaDuplikovat(this);

        return false;
    });


    $('.kombinaceDruhuZjednodusene').off('click', '.kombinaceDruhuZjednodusene-skupina-smazat');
    $('.kombinaceDruhuZjednodusene').on('click', '.kombinaceDruhuZjednodusene-skupina-smazat', function () {
        kombinaceDruhuZjednoduseneSkupinaSmazat(this);

        return false;
    });
}

$(document).ready(function() {
    kombinaceDruhuZjednoduseneInit();
});
